import * as React from "react";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import { Button, Typography } from "@mui/material";

const PREFIX = "LinkComponent";

const classes = {
  centerContactButton: `${PREFIX}-centerContactButton`,
  feedbackLink: `${PREFIX}-feedbackLink`,
};

const Root = styled("div")({
  [`& .${classes.centerContactButton}`]: {
    height: 40,
    margin: "10px auto 0 auto",
    display: "table",
    textTransform: "none",
    fontSize: "14px",
  },
  [`& .${classes.feedbackLink}`]: {
    marginTop: "1rem",
    marginBottom: "1rem",
  },
});

interface Props {
  appName: string;
  cert?: string;
}

function LinkComponent({ appName, cert }: Props) {
  const link = (
    <Root>
      {cert ? (
        <Button
          variant="outlined"
          id="contact-button"
          color="primary"
          className={clsx("contact-button", classes.centerContactButton)}
          onClick={() =>
            (window.location.href = `https://ask.fdic.gov/fdicinformationandsupportcenter/s/fdicdirform?app=${appName}&cert=${cert}`)
          }
        >
          Contact the FDIC
        </Button>
      ) : (
        <Typography variant="body2" className={classes.feedbackLink}>
          {" "}
          Provide{" "}
          <a
            id="feedback-link"
            href={`https://ask.fdic.gov/fdicinformationandsupportcenter/s/fdicdirform?app=${appName}`}
          >
            feedback or submit a question
          </a>{" "}
          about this page.
        </Typography>
      )}
    </Root>
  );
  return link;
}

export default LinkComponent;
